import { render, staticRenderFns } from "./DisplayLabel.vue?vue&type=template&id=15860180&"
import script from "./DisplayLabel.vue?vue&type=script&lang=js&"
export * from "./DisplayLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports